import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandYahooIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-yahoo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 6l5 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 18l7 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.5 6l5.5 7v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 13l6 -5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12.5 8l5 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 11l0 4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 18l0 .01"
    }, null), _createTextVNode(" ")]);
  }
};